<template>
    <div class="tw:space-y-4">
        <div>
            <BaseInputNumber
                label="Cantidad"
                :value="modelValue.cantidad"
                :min="1"
                :step="1"
                placeholder="0"
                @input="onCantidadInput"
            />
        </div>
        <BaseMultiselect
            label="Frecuencia"
            :value="modelValue.frecuencia"
            :options="frecuenciaOptions"
            label-key="label"
            value-key="value"
            :multiple="false"
            name="frecuencia"
            @input="updateFrecuencia"
        />
    </div>
</template>

<script setup>
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue'

    const frecuenciaOptions = [
        { value: 'Día/s', label: 'Día/s' },
        { value: 'Semana/s', label: 'Semana/s' },
        { value: 'Mes/es', label: 'Mes/es' }
    ]

    const props = defineProps({
        modelValue: {
            type: Object,
            default: () => ({ cantidad: null, frecuencia: '' })
        }
    })
    const emit = defineEmits(['update:modelValue'])

    function onCantidadInput(val) {
        update('cantidad', val)
    }

    function update(field, value) {
        emit('update:modelValue', { ...props.modelValue, [field]: value })
    }

    function updateFrecuencia(val) {
        update('frecuencia', val)
    }
</script>
